import { lazy, Suspense } from 'react';

const SbSharedPersonalizedFilterToastWrapper = lazy(
    () =>
        import(
            /* webpackChunkName: "SbSharedPersonalizedFilterToastWrapper" */ './SbSharedPersonalizedFilterToastWrapper.jsx'
        )
);

export default function SbSharedPersonalizedFilterToastLazy(props) {
    return (
        <Suspense fallback="">
            <SbSharedPersonalizedFilterToastWrapper {...props} />
        </Suspense>
    );
}
